import React from "react";
// javascript plugin used to create scrollbars on windows
import PerfectScrollbar from "perfect-scrollbar";
import { Route, Switch, Redirect } from "react-router-dom";

import DemoNavbar from "components/Navbars/DemoNavbar.js";
import Footer from "components/Footer/Footer.js";
import Sidebar from "components/Sidebar/Sidebar.js";
import { getLoggedInUserRole } from '../services/localstorage'
import routes from "routes.js";

var ps;

class Dashboard extends React.Component {
  constructor(props) {
    super(props);
    const role = getLoggedInUserRole()

    let routeData = []

    const copyRoutes = JSON.parse(JSON.stringify(routes));

    let sideBarRouteData = copyRoutes.filter((route) => {
      if(route.subRoutes && route.subRoutes.length > 0) {
        route.subRoutes = route.subRoutes.filter(subRoute => subRoute.requiredRoleIds && subRoute.requiredRoleIds.includes(role.id))
      }

      return route.requiredRoleIds && route.requiredRoleIds.includes(role.id)
    })

    routeData = routes.map((route) => {
      if(route.subRoutes && route.subRoutes.length > 0) return [...routeData, ...route.subRoutes]
    }).flat().filter((value) => {
      return !!value
    })

    let finalRoutes = [...routes, ...routeData]

    this.state = {
      backgroundColor: "black",
      activeColor: "info",
      routes: finalRoutes,
      sideBarRoutes: sideBarRouteData
    };

    this.mainPanel = React.createRef();

  }
  componentDidMount() {
    if (navigator.platform.indexOf("Win") > -1) {
      ps = new PerfectScrollbar(this.mainPanel.current);
      document.body.classList.toggle("perfect-scrollbar-on");
    }
  }
  componentWillUnmount() {
    if (navigator.platform.indexOf("Win") > -1) {
      ps.destroy();
      document.body.classList.toggle("perfect-scrollbar-on");
    }
  }
  componentDidUpdate(e) {
    if (e.history.action === "PUSH") {
      this.mainPanel.current.scrollTop = 0;
      document.scrollingElement.scrollTop = 0;
    }
  }
  handleActiveClick = (color) => {
    this.setState({ activeColor: color });
  };
  handleBgClick = (color) => {
    this.setState({ backgroundColor: color });
  };
  render() {
    return (
      <div className="wrapper">
        <Sidebar
          {...this.props}
          routes={this.state.sideBarRoutes}
          bgColor={this.state.backgroundColor}
          activeColor={this.state.activeColor}
        />
        <div className="main-panel" ref={this.mainPanel}>
          <DemoNavbar {...this.props} />
          <Switch>
            {this.state.routes.map((prop, key) => {
              return (
                <Route
                  path={prop.layout + prop.path}
                  component={prop.component}
                  key={key}
                  exact={prop.isExact}
                />
              );
            })}
            <Redirect from="/admin" to="/admin/dashboard" />
          </Switch>
          <Footer fluid />
        </div>
      </div>
    );
  }
}

export default Dashboard;
